import * as React from 'react';
import { useRef } from 'react';
import type { TextInput } from 'react-native';
import {
    LabelRegular,
    StyledBodyMediumRegularInputNoOutline,
    YStack,
} from 'smoothie';

import PaycheckRoutingCard from '../../paycheck-routing/common/PaycheckRoutingCard';

interface RuleEditorDescriptionProps {
    description?: string;
    updateDescription: (description: string) => void;
}

const RuleEditorDescription = ({
    description,
    updateDescription,
}: RuleEditorDescriptionProps) => {
    const inputRef = useRef<TextInput>(null);

    return (
        <YStack gap={8}>
            <LabelRegular marginLeft={8} color="$gray1100">
                Rule description (optional)
            </LabelRegular>
            <PaycheckRoutingCard
                onPress={() => {
                    inputRef.current?.focus();
                }}
            >
                {/* determine why cursor isn't blinking */}
                <StyledBodyMediumRegularInputNoOutline
                    ref={inputRef}
                    keyboardType="default"
                    value={description ?? ''}
                    onChangeText={(value) => {
                        updateDescription(value);
                    }}
                    returnKeyType="done"
                    height={22}
                />
            </PaycheckRoutingCard>
        </YStack>
    );
};

export default RuleEditorDescription;
